import { ReactNode } from 'react';

import { FALLBACK_RESOURCE_CENTER_URL } from '../../constant/url';
import { LottiePlayer } from '../common/LottiePlayer';
import { Description } from '../organisms';

export const Spinner = ({ title }: { title?: ReactNode }) => {
  return (
    <main className={'w-full h-[100vh] flex items-center justify-center'}>
      <div className="flex w-full h-full  items-center container-medium container-padding-large justify-center">
        <Description
          title={title ?? ' '}
          size={'medium'}
          graphic={
            <div className={'w-20 h-20'}>
              <LottiePlayer src={`${process.env.NEXT_PUBLIC_RESOURCE_CENTER_URL ?? FALLBACK_RESOURCE_CENTER_URL}/common/animation/ani_loader.json`} />
            </div>
          }
        />
      </div>
    </main>
  );
};
